<template>
  <div class="gallery user_images_gallery">
    <div class="upload_btn drop-area">
      <file-upload
        ref="upload"
        v-model="files"
        name="files[]"
        :post-action="uploadUserPhotoUrl"
        :data="{ customer: customer }"
        :multiple="true"
        @input-file="inputFile"
      >
        <button type="button" class="btn btn-primary">
          {{ $t("Upload your own files") }}
        </button>
      </file-upload>
    </div>
    <appImageEditorGallery :items="items" :hideDelete="false" />
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useCustomerStore } from "@/stores/modules/customer";
import { useUrlsStore } from "@/stores/modules/urls";
import { mapState, mapActions } from "pinia";

import VueUploadComponent from "vue-upload-component";
import * as R from "ramda";
import ImageEditorGallery from "../imageEditorGalleries/ImageEditorGallery";

export default {
  data() {
    return {
      files: []
    };
  },
  components: {
    "file-upload": VueUploadComponent,
    appImageEditorGallery: ImageEditorGallery
  },
  computed: {
    ...mapState(useImageEditorStore, { POIEVariables: "getPOIEVariables" }),
    ...mapState(useUrlsStore, { uploadUserPhotoUrl: "getuploadUserPhotoUrl" }),
    ...mapState(useCustomerStore, {
      customer: "getCustomer",
      items: "getCustomerImageGalleryItems"
    })
  },
  methods: {
    ...mapActions(useCustomerStore, [
      "loadCustomerGallery",
      "addCustomerImage",
      "emptyCustomerGallery"
    ]),
    inputFile(newFile, oldFile) {
      this.$refs.upload.active = true;
      if (newFile.success) {
        const { success, data } = newFile.response;
        if (success) {
          R.forEach(item => {
            item.uploaded = true;
            this.addCustomerImage(item);
          }, data);
        }
      }
    }
  },
  created() {
    this.loadCustomerGallery();
  },
  watch: {
    customer: function () {
      this.emptyCustomerGallery();
      this.loadCustomerGallery();
    }
  }
};
</script>
